
export const userRegister = {
  register: {
    confirmPassword: {
      action: 'Confirm Password',
      label: 'Confirm Password',
      placeholder: 'Confirm Password',
    },
    managementInMyAccount: 'Management in My Account.',
    termsAndConditions: 'Terms & Conditions',
    signIn: 'I already have an account. Sign In',
    register: 'Register',
    confirmNewPassword: 'Confirm New Password',
    resetPassword: 'Reset Password',
    createAccount: 'Create an account',
    title: 'Title',
    firstName: {
      label: 'First Name',
      placeholder: 'First Name',
    },
    lastName: {
      label: 'Last Name',
      placeholder: 'Last Name',
    },
    emailAddress: {
      label: 'Email Address',
      placeholder: 'Email Address',
      invalidFormat: 'Invalid Email Format. Please use format: name@company.com',
    },
    confEmailAddress: {
      label: 'Confirm Email Address',
      placeholder: 'Confirm Email Address',
    },
    accountNumber: {
      label: 'Account Number',
      placeholder: 'Account Number',
    },
    jobFunction: {
      label: 'Job Function',
      placeholder: 'Job Function',
    },
    contactNumber: {
      label: 'Phone Number',
      placeholder: 'Phone Number',
      invalidFormat: 'Invalid Phone Format. Please use format: (XXX) XXX-XXXX',
    },
    password: {
      label: 'Password',
      placeholder: 'Password',
    },
    titleField: {
      label: 'Title',
      placeholder: 'Enter Title',
    },
    newPassword: 'New Password',
    emailMarketing:
      'Use my personal data to receive e-mail newsletters for marketing campaigns. To change your settings, go to Consent Management in My Account.',
    confirmThatRead: 'I am confirming that I have read and agreed with the',
    selectTitle: 'Select Title',
    passwordMinRequirements:
      'Password must be six characters minimum, with one uppercase letter, one number, one symbol',
    bothPasswordMustMatch: 'Both password must match',
    titleRequired: 'Title is required.',
    postRegisterMessage: 'Please log in with provided credentials.',
    pageHeader1: 'New User Request',
    userInformation: 'User Information',

    address: {
      label: 'Address',
      placeholder: 'Enter Address',
    },
    city: {
      label: 'City',
      placeholder: 'Enter City',
    },
    country: {
      label: 'Country',
      placeholder: 'Select Country',
    },
    state: {
      label: 'State/Province',
      placeholder: 'Select State/Province',
    },
    zipCode: {
      label: 'ZIP code/Postal Code',
      placeholder: 'Enter ZIP Code/Postal Code',
    },
    languagePreference: {
      label: 'Language Preference',
      placeholder: 'Select Language',
    },
    accountInformation: 'Account Information',
    customerType: {
      label: 'Customer Type',
      placeholder: 'Select Customer Type',
    },
    employeeId: {
      label: 'Employee ID',
      placeholder: 'Enter Employee ID',
    },
    soldToAccounts: 'Sold To Accounts',
    soldToAccountNumber: {
      label: 'Sold To Account # (Agent Account#)',
      placeholder: 'Enter Account Number',
    },
    companyName: {
      label: 'Company Name',
      placeholder: 'Enter Company Name',
    },
    addressLine1: {
      label: 'Sold To Address Line 1',
      placeholder: 'Enter Address Line 1',
    },
    addressLine2: {
      label: 'Sold To Address Line 2',
      placeholder: 'Enter Address Line 2',
    },
    soldToCity: {
      label: 'Sold To City',
      placeholder: 'Enter City',
    },
    soldToCountry: {
      label: 'Sold To Country',
      placeholder: 'Select Country',
    },
    soldToZipCode: {
      label: 'Sold To ZIP Code/Postal Code',
      placeholder: 'Enter ZIP Code/Postal Code',
    },
    soldToState: {
      label: 'Sold To State/Province',
      placeholder: 'Select State/Province',
    },
    deleteAccount: 'Delete Account',
    addMoreSoldToAccounts: 'Add more Sold To accounts for this division',
    removeSoldToAccountEntry: 'Remove Sold To Account Entry',
    captcha: {
      label: 'Verification',
      required: 'Please verify that you are not a robot',
    },
  },
};